import {
  assertIsCombinedElementType,
  type Combined,
} from '@bizzdesign/sdk-knowledgegraph';
import { relationRoleMap } from '@bizzdesign/modeler/models';

/**
 * Returns one side of the relation direction, as a relationRoleName based on the fully metaModelTerm of the relation.
 * @param metaModelTerm The full metaModelTerm (formatted like `Metamodel:TypeName`)
 * @returns relation role name (ex: `dependsOn`, `aggregates`)
 */
export function convertTypeNameToRelationRoleName(
  metaModelTerm: string,
): Combined.RelationRoleName {
  const roleName = relationRoleMap.get(metaModelTerm);
  if (!roleName)
    throw new Error('Relation Type has no mapped version for SDK!');

  return roleName;
}

/**
 * Converts the full metaModelTerm into a format the SDK expects. So converts Metamodel:TypeName -> Metamodel.TypeName.
 * If the param isn't in Metamodel:TypeName format, function defaults to BDCore.TypeName.
 * If the resulting type is not supported by the SDK, it throws an error.
 * @param typeName full metaModelTerm to be converted
 * @returns Converted type to Metamodel.TypeName format
 */
export function convertTypeNameToSdkElementType(
  typeName: string,
): Combined.ElementType {
  const [typeLang, typeSansLang] = typeName.split(':');

  // ex: HardwareTechnology -> BDCore.HardwareTechnology
  const typeWithPrefix =
    !!typeLang && !!typeSansLang
      ? `${typeLang}.${typeSansLang}`
      : `BDCore.${typeName}`;
  assertIsCombinedElementType(typeWithPrefix);
  return typeWithPrefix;
}

/**
 * Converts SDK object type from ArchiMate.ObjectType to ArchiMate:ObjectType
 */
export function convertFromSdkObjectTypeToMetaModelTerm(
  sdkObjectType?: string,
): string {
  if (!sdkObjectType) return '';
  const newTypeString = sdkObjectType.replace('.', ':');
  return newTypeString;
}
